export const getDtiLocations = (state) => state.dtiLocation.locationsList;
